import { z } from 'zod';
export const gameweekEntitySchema = z.object({
    id: z.string().uuid(),
    season_id: z.string().uuid(),
    number: z.number().int(),
    fpl_id: z.number().int().nullable(),
    name: z.string(),
    deadline_time: z.string().nullable(),
    finished: z.boolean(),
    is_current: z.boolean(),
    is_next: z.boolean(),
    is_previous: z.boolean(),
    created_at: z.string(),
    updated_at: z.string(),
});
